import React from 'react';
import '../styles/Home.css';

const Spinner = () => {
    return (
        <div id="overlay"><img src="/../../images/ajax-loader.gif" class="loading_circle" alt="loading" /></div>
    );
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.jsx